import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, NUMBERS, PRODUCT_TYPE_CONSTANT_NAME } from '../../../constants/app.constants';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

@Component({
  selector: 'app-suggestion-tag-card',
  templateUrl: './suggestion-tag-card.component.html',
  styleUrls: ['./suggestion-tag-card.component.scss']
})
export class SuggestionTagCardComponent implements OnChanges {

  @Input() sugg;
  @Input() hasChanged;
  @Input() deleteTagObj;
  @Output() resetErrorMsg = new EventEmitter();
  @Input() callingFrom: string;
  finished = false;
  err_msg = '';
  showTagProcessed = false;

  connection_pic_image = {
    prflclass: 'user-40 text-center rounded-circle text-white d-table-cell align-middle',
    prflpic: '',
    prflfname: '',
    prflmname: '',
    prfllname: '',
    prflrname: '',
    prflcid: '',
    prfltype: '',
    prflpicclass: 'c-profile-pic rounded-circle user-40 post-pic',
    badge: { is_verified: 0, is_show: true },
    full_name: '',
    is_action: false,
    partial_permission_state: ''
  };

  constructor(public dss: DataStorageService, public multilang: MultiLangService, public mls: NewLanguageService, private analyticSdk: Analytics) { }

  ngOnChanges(): void {
    if (this.deleteTagObj == this.sugg.custom_id) {
      this.showTagProcessed = false;
    }

    this.connection_pic_image.prflrname = this.sugg.registered_name;
    this.connection_pic_image.prflpic = this.sugg.profile_pic;
    this.connection_pic_image.prflcid = this.sugg.custom_id;
    this.connection_pic_image.prflfname = this.sugg.first_name;
    this.connection_pic_image.prfllname = this.sugg.last_name;
    this.connection_pic_image.full_name = this.sugg.full_name;
    this.connection_pic_image.badge.is_verified = (this.sugg.permission == 'all') ? 1 : 0;
    this.connection_pic_image.partial_permission_state = this.sugg.partial_permission_state;



    this.dss.posting_data.screen1.tag_to.forEach(el => {
      if (el.custom_id == this.sugg.custom_id) {
        this.showTagProcessed = true;
      }
    });

  }

  addTagTo(e, conn): boolean {
    // this.err_msg='';
    //   if(this.dss.posting_data.screen1.tag_to.length>4)
    //   {
    //     this.err_msg='You can tag max 5 members';
    //     e.target.checked=false;
    //     this.resetErrorMsg.emit(0);
    //     return false;
    //   }
    //   this.showTagProcessed=true;
    //   this.dss.posting_data.screen1.tag_to.push(conn)
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', this.callingFrom, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.CONNECT_AND_TAG, null);
    this.err_msg = '';
    if (this.dss.tagedUser.length > 4) {
      this.err_msg = 'You can tag max 5 members';
      e.target.checked = false;
      this.resetErrorMsg.emit(0);
      return false;
    }
    this.showTagProcessed = true;
    const index = this.dss.tagedUser.findIndex((item) => {
      return item.custom_id === conn.custom_id;
    });
    if (index === NUMBERS.MINUS_ONE) { this.dss.tagedUser.push(conn); }
  }

  /**
   * Check if request sent or not
   */
  checkVal(conn): boolean {
    const suggestion = this.dss.tagedUser.filter(suggestion => suggestion.custom_id === conn.custom_id);
    return (suggestion.length > NUMBERS.ZERO) ? true : false;
  }

}
